import { Label } from "../Label"
import { StarAnim } from "../StarAnim"
import roundLight from "../../assets/round_light.png"
import styles from './styles.module.scss'
import { FifteenFriendsIcon } from "../../icons/FifteenFriendsIcon"


type Props = {
    label: string
}

export const Condition5Art = ({ label }: Props) => {
    return <div className={styles.container}>

        <div className={styles.iconWrap}>
            <FifteenFriendsIcon />
        </div>
        <img src={roundLight} alt="" className={styles.roundLight} aria-hidden />
        <Label label={label} />
        <div className={styles.starAnimWrap}>
            <StarAnim width={140} height={140} className={styles.starAnim} />
        </div>
    </div>
}